var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCloseCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_close_circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_close_circle",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(5.000000, 5.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(0.792891, 0.795751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.68364527,0.316989904 L0.324039128,4.70286544 C-0.0653103635,5.09456101 -0.0634084916,5.72772313 0.328287077,6.11707262 C0.719982646,6.50642211 1.35314477,6.50452024 1.74249426,6.11282467 L6.1021004,1.72694914 C6.49144989,1.33525357 6.48954802,0.702091445 6.09785245,0.312741954 C5.70615688,-0.0766075371 5.07299476,-0.0747056652 4.68364527,0.316989904 Z",
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.291394938,1.70560532 L4.64955609,6.08229453 C5.03925114,6.4736463 5.6724147,6.47498935 6.06376647,6.0852943 C6.45511825,5.69559925 6.4564613,5.06243569 6.06676625,4.67108392 L1.70860509,0.29439471 C1.31891004,-0.0969570676 0.685746487,-0.0983001114 0.29439471,0.291394938 C-0.0969570676,0.681089987 -0.0983001114,1.31425354 0.291394938,1.70560532 Z",
    id: "Path-7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M10.6503786,6.29502041 L6.29077246,10.6808959 C5.90142297,11.0725915 5.90332484,11.7057536 6.29502041,12.0951031 C6.68671598,12.4844526 7.3198781,12.4825507 7.70922759,12.0908552 L12.0688337,7.70497964 C12.4581832,7.31328408 12.4562814,6.68012195 12.0645858,6.29077246 C11.6728902,5.90142297 11.0397281,5.90332484 10.6503786,6.29502041 Z",
    id: "Path-7",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29139494,7.70560532 L10.6495561,12.0822945 C11.0392511,12.4736463 11.6724147,12.4749893 12.0637665,12.0852943 C12.4551183,11.6955992 12.4564613,11.0624357 12.0667662,10.6710839 L7.70860509,6.29439471 C7.31891004,5.90304293 6.68574649,5.90169989 6.29439471,6.29139494 C5.90304293,6.68108999 5.90169989,7.31425354 6.29139494,7.70560532 Z",
    id: "Path-7",
    fill: "#B1B1B1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseCircle);
export default __webpack_public_path__ + "static/media/icon_close_circle.beab6a683d7bf9d623d9e6da2c8621b1.svg";
export { ForwardRef as ReactComponent };